import { styled } from "@mui/material/styles";
import { Box, Backdrop, Grid2 } from "@mui/material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const GridContainer = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(4),
  flexWrap: "wrap",
}));
